// The `customEvent` namespace (Scraping as a Service), extracted from en.ts so the
// (over-length) main translation file stays within the architecture-gate line ratchet.
import { enCustomEventRescrape } from "./enCustomEventRescrape";

export const enCustomEvent = {
	requestButton: "Request",
	rescrape: enCustomEventRescrape,
	title: "Websites",
	search: "Search for event",
	name: "Name",
	status: "Status",
	namePlaceholder: "Name of the event",
	urlPlaceholder: "URL of the event",
	loginNotesPlaceholder: "Login notes",
	usernamePlaceholder: "Username",
	passwordPlaceholder: "Password",
	otpSecretPlaceholder: "OTP Secret",
	subtitle: "Your Сustom events",
	url: "URL of Сustom Event ",
	email: "Email",
	found: "Found",
	downloads: "Downloads",
	processed: "Processed",
	personList: "Person List",
	organizationList: "Organization List",
	create: {
		button: "Create new Сustom Event",
		title: "Create new Сustom Event",
	},
	listProvidedUntil: "List provided until",
	eventAt: "Event at",
	loginNotes: "Login notes",
	username: "Username",
	password: "Password",
	otpSecret: "OTP Secret",
	reset: {
		title: "Reset assigned files",
	},
	reassign: "Assign files to industry event",
	reassignDescription: "Please select the files that you want to assign to the custom event.",
	eventType: "Event Type",
	company: "Company",
	listProvidedAt: "List provided at",
	file: "File",
	entityType: "List type",
	listName: "List name",
};
